import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { isWebpSupported } from "react-image-webp/dist/utils";
import CookieConsent from "react-cookie-consent";

import "./App.css";
import Router from "./Router";

const App = () => {
  useEffect(() => {
    document.body.classList.add(
      `${isWebpSupported() ? "webp-supported" : "no-webp-supported"}`
    );
  }, []);

  return (
    <div className="App" id="scrool">
      <Router />
      <ToastContainer />
      <CookieConsent
        location="bottom"
        buttonText="OK"
        cookieName="cookie-consent-validation"
        style={{ background: "#2B373B" }}
        buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
        expires={150}
      >
        O nosso website utiliza cookies para melhorar e personalizar a sua
        experiência de navegação. Ao continuar a navegar está a consentir a
        utilização de cookies.
      </CookieConsent>
    </div>
  );
};

export default App;
